import { GrowthBook } from "@growthbook/growthbook";
import * as features from "@/scripts/store/features";

const gb = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-bFMPGDFC9sMwhjsE",
  enableDevMode: process.env.NODE_ENV === "development",
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "viewed_experiment",
      experimentId: experiment.key,
      variationId: result.key
    });
  }
});
window.gb = gb; // Expose for debugging


//===========================
// Collect user attributes
//===========================

//should match tailwind.config.js
const screens = {
  'sm': '700px',
  'md': '1000px',
  'lg': '1150px',
  'xl': '1400px',
  '2xl': '1600px',
}

const screenSize = Object.keys(screens).reverse().find((key) => {
  return window.innerWidth > parseInt(screens[key]);
});

const waitForHeapId = function(){
  return new Promise((resolve, reject) => {
    const heapId = window.heap.getUserId();
    if(heapId){
      setGbAttributes(heapId);
      resolve();
    }else{
      window.addEventListener("heapReady", function (event) {
        setGbAttributes(window.heap.getUserId());
        resolve();
      });
    }
  });
}

const setGbAttributes = function(id){
  console.log("growthbook", id);
  gb.setAttributes({
    id: id,
    email: window?.userAttributes?.email,
    customerId: window?.userAttributes?.customerId,
    totalSpent: window?.userAttributes?.totalSpent,
    ordersCount: window?.userAttributes?.ordersCount,
    tags: window?.userAttributes?.tags,
    country: Shopify.country,
    locale: Shopify?.locale,
    currency: Shopify?.currency?.active,
    url: window.location.href,
    userAgent: navigator.userAgent,
    screenWidth: window.innerWidth,
    screenSize: screenSize,
    themeId: Shopify.theme.id,
    themeName: Shopify.theme.name,
    themeRole: Shopify.theme.role
  });
}

//===========================
// setup growthbook
//===========================

export const setupGrowthbook = async function(){

    await waitForHeapId();

    // Wait for features to be available
    await gb.loadFeatures();

    let params = new URL(document.location).searchParams;

    for(const key in features){
      const feature = features[key];
      const override_value = params.get(`gb_${feature.key}`) == 'false' ? false : params.get(`gb_${feature.key}`);
      const value = gb.getFeatureValue(feature.key);
      if(typeof value != "undefined" || override_value != null){
        if(override_value != null){
          console.log(feature.key, "override", override_value)
          feature.init(override_value);
        }else{
          console.log(feature.key, value)
          feature.init(value);
        }
      }
    }

    gb.setRenderer(() => {
      console.log("GrowthBook renderer", features);
      for(const key in features){
          const feature = features[key];
          const override_value = params.get(`gb_${feature.key}`) == 'false' ? false : params.get(`gb_${feature.key}`);
          const value = gb.getFeatureValue(feature.key);
          if(typeof value != "undefined" || override_value != null){
            if(override_value != null){
              console.log(feature.key, "override", override_value)
              feature.init(override_value);
            }else{
              console.log(feature.key, value)
              feature.init(value);
            }
          }
      }
    });

}

// if(process.env.NODE_ENV === "development"){
//   window.addEventListener("message", function (event) {
//     const data = event.data;
//     if(data?.type == 'GB_REFRESH'){
//       console.log("GrowthBook refresh", data);
//       let params = new URL(document.location).searchParams;
//       for(const key in features){
//         const feature = features[key];
//         const override_value = params.get(`gb_${feature.key}`);
//         const gbFeature = data.features[feature.key];
//         if(gbFeature || override_value != null){
//           if(override_value != null){
//             console.log(feature.key, "override", override_value)
//             feature.init(override_value);
//           }else{
//             console.log(feature.key, gbFeature.defaultValue)
//             feature.init(gbFeature.defaultValue);
//           }
//         }
//       }
//     }
//   });
// }